// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gSsBw","legend":"styles_legend__elkqe"};